import { useContext } from 'react';
import { PosterContext } from '../context/PosterContext';

export const useGetPosters = () => {
    const { posters, getPosters, setPosters } = useContext(PosterContext);
    
    return {
        posters,
        setPosters,
        getPosters: (latitude, longitude) => getPosters(latitude, longitude)
    }
}
